import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import {
  EventNote as EventNoteIcon,
  FilterList as FilterListIcon,
} from '@mui/icons-material';

interface TimelineEmptyProps {
  hasFilters?: boolean;
  customerId?: number;
}

const TimelineEmpty: React.FC<TimelineEmptyProps> = ({ hasFilters = false, customerId }) => {
  
  const handleForceSetupData = async () => {
    if (import.meta.env.DEV && window.confirm('デモデータを強制的に再設定しますか？')) {
      try {
        // InitialDataServiceをwindowオブジェクト経由で呼び出す
        const InitialDataService = (window as any).InitialDataService;
        if (InitialDataService?.forceSetupDemoData) {
          await InitialDataService.forceSetupDemoData();
          window.location.reload();
        } else {
          alert('InitialDataServiceが利用できません');
        }
      } catch (error) {
        console.error('Failed to force setup demo data:', error);
        alert('デモデータの設定に失敗しました');
      }
    }
  };
  
  return (
    <Paper
      sx={{
        p: 6,
        textAlign: 'center',
        bgcolor: 'grey.50',
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          p: 3,
          borderRadius: '50%',
          bgcolor: '#ffffff',
          mb: 3,
        }}
      >
        {hasFilters ? (
          <FilterListIcon sx={{ fontSize: 48, color: 'text.secondary' }} />
        ) : (
          <EventNoteIcon sx={{ fontSize: 48, color: 'text.secondary' }} />
        )}
      </Box>
      
      <Typography variant="h6" gutterBottom>
        {hasFilters ? '該当する施術記録がありません' : '施術記録がまだありません'}
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {hasFilters
          ? 'フィルター条件を変更して再度お試しください'
          : '新しい施術記録を作成して、お客様の施術履歴を管理しましょう'}
      </Typography>
      
      {/* 開発環境用のデバッグ情報 */}
      {import.meta.env.DEV && !hasFilters && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="caption" color="warning.main" sx={{ display: 'block', mb: 1 }}>
            開発環境：データが表示されない場合は、初期データの設定に問題がある可能性があります。
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            顧客ID: {customerId} | localStorage key: treatments_{customerId}
          </Typography>
        </Box>
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
        {/* 開発環境用のデモデータ再設定ボタン */}
        {import.meta.env.DEV && !hasFilters && (customerId === 1001 || customerId === 1002) && (
          <Button
            variant="outlined"
            color="warning"
            onClick={handleForceSetupData}
            size="small"
          >
            デモデータを強制再設定（開発用）
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default TimelineEmpty;